"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenomeControl = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const DiscardCards_1 = require("../../../deferredActions/DiscardCards");
class GenomeControl {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.GENOME_CONTROL;
        this.description = 'The player(s) with the most unique tags in play (reduced by influence) discards 2 cards. SOLO: Discard 2 cards if you have 5+ unique tags, reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.SPOME;
        this.currentDelegate = PartyName_1.PartyName.BUREAUCRATS;
    }
    resolve(game, turmoil) {
        if (game.isSoloMode()) {
            const player = game.getPlayers()[0];
            if (player.getDistinctTagCount('globalEvent') - turmoil.getPlayerInfluence(player) >= 5)
                this.discardCards(player, game);
        }
        else {
            const players = [...game.getPlayers()].sort((p1, p2) => this.getScore(p2, turmoil) - this.getScore(p1, turmoil));
            if (this.getScore(players[0], turmoil) > this.getScore(players[1], turmoil)) {
                this.discardCards(players[0], game);
            }
            else {
                const score = this.getScore(players[0], turmoil);
                while (players.length > 0 && this.getScore(players[0], turmoil) === score) {
                    this.discardCards(players[0], game);
                    players.shift();
                }
            }
        }
    }
    getScore(player, turmoil) {
        return Math.max(player.getDistinctTagCount('globalEvent') - turmoil.getPlayerInfluence(player), 0);
    }
    discardCards(player, game) {
        if (player.cardsInHand.length >= 2) {
            game.defer(new DiscardCards_1.DiscardCards(player, 2, 'Global Event - Select 2 cards to discard'));
        }
        else if (player.cardsInHand.length === 1) {
            game.defer(new DiscardCards_1.DiscardCards(player, 1, 'Global Event - Select a card to discard'));
        }
    }
}
exports.GenomeControl = GenomeControl;
//# sourceMappingURL=GenomeControl.js.map